import {SearchDisplayContext} from 'common/report/util/search/types';
import {QueryReportHeaderSave} from 'common/query-builder/query-report-header/types';

export type QueryReportTitleProps = {
  allowStaffOverride: boolean;
  className?: string;
  canSave: boolean;
  canWrite: boolean;
  displayContext: SearchDisplayContext;
  emptyEntityName?: string;
  entityDescription: string;
  entityName: string;
  projectId: number;
  hasUnsavedChanges: boolean;
  invalidEntity: boolean;
  isSuperadmin: boolean;
  onSave: (params: QueryReportHeaderSave) => void;
  selectedEntityId: number | null;
  trackName: string;
  workspaceId: number;
};

export enum TrackingEvent {
  ReportSaved = `Report saved`,
  StartReportEditDescription = `Start Report Edit Description`,
  StartReportRename = `Start Report Rename`,
}
